import PeopleSearch from './PeopleSearch';

export default PeopleSearch;
